import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import TablePage from "./pages/Table";
import Fixtures from "./pages/Fixtures";
import EnterMatch from "./pages/EnterMatch";
import Stats from "./pages/Stats";
import PlayerProfile from "./pages/PlayerProfile";
import Admin from "./pages/Admin";
import CareerRecords from "./pages/CareerRecords";
import MatchReport from "./pages/MatchReport";
import MatchdayReport from "./pages/MatchdayReport";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/tabelle" element={<TablePage />} />
            <Route path="/spielplan" element={<Fixtures />} />
            <Route path="/erfassen" element={<EnterMatch />} />
            <Route path="/statistik" element={<Stats />} />
            <Route path="/spieler/:id" element={<PlayerProfile />} />
            <Route path="/rekorde" element={<CareerRecords />} />
            <Route path="/bericht/:id" element={<MatchReport />} />
            <Route path="/spieltag-bericht/:id" element={<MatchdayReport />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
